<template>
  <modal-component
    :is-displayed="true"
    :is-full-screen-modal="true"
    :remove-outside-click="true"
    :title="modalTitle"
    @toggle-modal="$emit('toggle-modal')"
  >
    <div v-if="isLoading" class="flex w-full items-center justify-center">
      <small-loader />
    </div>
    <div v-else class="px-5">
      <custom-table
        :allow-auto-resize="true"
        :is-action-list-not-displayed="true"
        :is-data-source-loading="isSpotAssignHistoryListLoading"
        :table-data="spotAssignHistory"
        :table-headers="tableHeaders"
        @force-refresh="getSpotAssignHistory"
      />
    </div>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import CustomTable from "@/core/Components/CustomTable.vue";
import { ErrorMessageFormatter, isString } from "@/core/Services/GlobalFunctions";
import { useToast } from "vue-toastification";
import Loader from "@/core/Components/Loader.vue";
import SmallLoader from "@/core/Components/SmallLoader.vue";
import { Sensor, SpotAssignHistory } from "../../Sensors/Services/SensorTypes";
import SensorService from "../../Sensors/Services/SensorService";

export default defineComponent({
  components: {
    SmallLoader,
    Loader,
    CustomTable,
    ModalComponent,
  },
  props: {
    isSpotAssignHistoryModalOpened: Boolean,
    refreshData: {
      type: Function,
      required: true,
    },
    sensor: {
      type: Object as PropType<Sensor> | undefined,
      required: true,
    },
  },
  emits: ["toggle-modal"],
  data() {
    return {
      sensorService: new SensorService(),
      toast: useToast(),
      spotAssignHistory: [] as SpotAssignHistory[],
      selectedHistoryRecord: {} as SpotAssignHistory,
      isLoading: false,
      isSpotAssignHistoryListLoading: false,
      tableHeaders: {
        spotName: { header: "SpotAssignHistory.Spot", visible: true },
        spaceName: { header: "SpotAssignHistory.Space", visible: true },
        userEmail: { header: "SpotAssignHistory.User", visible: true },
        date: { header: "SpotAssignHistory.Date", visible: true },
      },
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.getSpotAssignHistory();
    } catch (error) {
      this.toast.error(ErrorMessageFormatter(error));
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async getSpotAssignHistory() {
      this.isSpotAssignHistoryListLoading = true;
      try {
        this.spotAssignHistory = await this.sensorService.getSpotAssignHistory({
          pageNumber: 1,
          pageSize: 100000,
          sensorMac: this.sensor.mac,
        });
      } catch (error: any) {
        if (!isString(error.response.data)) {
          this.toast.error(ErrorMessageFormatter(error.response.data));
          return;
        }
        this.toast.error(error.response.data);
      } finally {
        this.isSpotAssignHistoryListLoading = false;
      }
    },
    getSelectedRows(values: SpotAssignHistory[]) {
      if (values.length) {
        this.selectedHistoryRecord = values[0];
      }
    },
  },
  computed: {
    modalTitle() {
      return `${(this as any).$t("Sensors.SpotAssignHistoryTitle")} ${this.sensor.mac}`;
    },
  },
});
</script>

<style scoped></style>
